import constants from "../../core/constants";
import moment from "moment";

class Controller {
  constructor(CaptainFinanceTransforms, ActionLists, Sections) {
    "ngInject";

    this.fields = CaptainFinanceTransforms.fields;
    this.day = moment().format(constants.dateFormat);
    this.captainFinanceActions = ActionLists.all.captainFinanceActions;
    this.sections = Sections.plansSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captainFinance/captainFinance.controller.js